import React from 'react'

const NigeriaReq = () => {
  return (
    <div>
      
    </div>
  )
}

export default NigeriaReq
